import { useTranslation } from "react-i18next";
import { SUPPORTED_LOCALES } from "../i18n/index.ts";

export function LocaleSwitch() {
  const { t, i18n } = useTranslation();
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="sr-only">{t("account.language")}</span>
      <select
        className="rounded-md border border-(--saa-border) bg-(--saa-surface) px-2 py-1 text-sm"
        value={i18n.language}
        onChange={(e) => {
          void i18n.changeLanguage(e.target.value);
          try {
            localStorage.setItem("saa_locale", e.target.value);
          } catch {
            // trình duyệt chặn localStorage: ngôn ngữ chỉ giữ trong phiên này
          }
          document.documentElement.lang = e.target.value;
        }}
      >
        {SUPPORTED_LOCALES.map((l) => (
          <option key={l} value={l}>
            {t(`locale.${l}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
